module.exports = __webpack_public_path__ + "static/media/workingmemory-numbers-10.70c8f832.mp3";